module.exports = __webpack_public_path__ + "static/img/bnf.71534004.svg";